import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import InsuranceForm from './component/InsuranceForm';
import { useStateGlobalContext } from '../../../../../../contexts/GlobalContext';
import Loader from '../../../../../../components/Loader/Loader'; 

function AutoInsurance() {
  const { id } = useParams();
  const { insuranceData, getInsuranceData } = useStateGlobalContext();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getInsuranceData(id, 'auto');
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) {
    return <Loader />;
  }

  return (
    <InsuranceForm
      insuranceType="auto"
      id={id}
      insuranceData ={insuranceData}
      getInsuranceData={getInsuranceData}
    />
  );
}

export default AutoInsurance;
